<script setup>
import { ref } from 'vue'

const messages = ref([])
let messageId = 0

const createMessage = (type, content) => {
  const id = messageId++
  const message = {
    id,
    type,
    content,
  }
  messages.value.push(message)
  setTimeout(() => {
    removeMessage(id)
  }, 3000)
}

const removeMessage = (id) => {
  const index = messages.value.findIndex(msg => msg.id === id)
  if (index !== -1) {
    messages.value.splice(index, 1)
  }
}

// 导出全局方法
const $message = {
  success: (content) => createMessage('success', content),
  error: (content) => createMessage('error', content),
  warning: (content) => createMessage('warning', content),
  info: (content) => createMessage('info', content),
}

// 挂载到全局
window.$message = $message
</script>

<template>
  <div class="fixed left-1/2 top-1/6 z-[10000] space-y-2 transform -translate-y-1/2 -translate-x-1/2">
    <div
      v-for="msg in messages"
      :key="msg.id"
      class="alert shadow-lg max-w-xs animate-slide-in-right text-white"
      :class="{
        'alert-success': msg.type === 'success',
        'alert-error': msg.type === 'error',
        'alert-warning': msg.type === 'warning',
        'alert-info': msg.type === 'info'
      }"
    >
      <span>{{ msg.content }}</span>
    </div>
  </div>
</template>

<style scoped>
.animate-slide-in-right {
  animation: slide-in-top 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes slide-in-right {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>